// Reusable "open in Xero" deep-link button — a white box with the blue Xero logo.
// Use everywhere a link opens a document/journal/record in Xero for a consistent look.
export const XeroLink = ({ href, size = "md", testId, title = "View in Xero", className = "" }) => {
  if (!href) return null;
  const cfg = size === "sm"
    ? { box: "h-6 px-2 rounded-md", logo: "h-2.5" }
    : { box: "h-9 px-3.5 rounded-lg", logo: "h-4" };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      title={title}
      className={`inline-flex items-center justify-center bg-white border border-slate-200 hover:border-[#13B5EA] hover:shadow-sm transition-all ${cfg.box} ${className}`}
    >
      <img src="/xero-logo-blue.png" alt={title} className={`w-auto ${cfg.logo}`} />
    </a>
  );
};
